import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Navigation } from "./components/Navigation";
import { Hero } from "./components/Hero";
import { Stats } from "./components/Stats";
import { Gallery } from "./components/Gallery";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { CTABanner } from "./components/CTABanner";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { PageLoader } from "./components/PageLoader";
import { Toaster } from "./components/ui/sonner";
import { BookingClosedBanner } from "./components/BookingClosedBanner";
import { AuthProvider } from "./contexts/AuthContext";
import { BookingStatusProvider } from "./contexts/BookingStatusContext";
import { ResetPassword } from "./components/ResetPassword";
import { EmailVerification } from "./components/EmailVerification";
import { SEO } from "./components/SEO";
import { StructuredData } from "./components/StructuredData";

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BookingStatusProvider>
        <Router>
          <SEO />
          <StructuredData />
          <PageLoader />
          <Routes>
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/verify-email/:token" element={<EmailVerification />} />
            <Route path="/" element={
              <div className="min-h-screen">
                <BookingClosedBanner />
                <Navigation />
                <Hero />
                <Stats />
                <Gallery />
                <WhyChooseUs />
                <CTABanner />
                <Contact />
                <Footer />
                <ScrollToTop />
              </div>
            } />
          </Routes>
          <Toaster />
          {/* Powered by Larnis branding */}
          <a
            href="https://larnis.com"
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-4 left-4 text-xs text-gray-400/70 hover:text-gray-500 transition-colors duration-200 z-[60] backdrop-blur-sm"
          >
            Powered by Larnis
          </a>
        </Router>
        </BookingStatusProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}
